import React from "react";
import "../../assets/scss/time-based.scss";
import "../../assets/scss/time-based-summary.scss";
import "../../assets/scss/autocomplete.scss";
import "../../assets/scss/setting-table.scss";
import AddTimePhase from "../small-components/AddTimePhase";
import GanttContainerApp from "../timeline/ganttContainer/GanttContainerApp";
import Summary from "../small-components/summary";
import Notes from "../small-components/notes";
import $ from "jquery";
import { useHistory, withRouter } from "react-router-dom";
import { Button, Grid, Typography } from "@material-ui/core";

class TimeBased extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      phaseAppend: [],
      speed: false,
      buttonShow: true,
      overlay: "",
      value: "scope",
    };
  }

  autofill = (e, id) => {
    const myText = e.target.innerText || e.target.textContent;
    document.getElementById(id).value = myText;
  };

  addPhase = (r) => {
    this.setState({
      speed: true,
      type: r,
    });
    setTimeout(() => {
      this.setState({
        phaseAppend: [
          ...this.state.phaseAppend,
          <AddTimePhase
            type={this.state.type}
            key={this.state.phaseAppend.length}
            phase={this.addPhase}
          />,
        ],
        buttonShow: false,
      });
    }, 100);
  };
  showButton = () => {
    this.setState({
      buttonShow: true,
    });
  };
  toggleDrawer = (anchor, open, type) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ ...this.state, [anchor]: open, overlayType: type });
  };
  overlayTypes = (anchor, open, type) => {
    this.setState({ ...this.state, [anchor]: open, overlayType: type });
  };
  handleChange = (e) => {
    e.currentTarget.closest(".summary-table").classList.toggle("expandTime");
    const row = e.currentTarget.closest(".summary-table");
    $(row).find(".summary-body").slideToggle();
  };
  render() {
    // const [value, setValue] = React.useState("scope");

    const { value } = this.state;
    const props = this.props;
    const pathArr = props.location.pathname.split('/');
    const key = pathArr[pathArr.length - 1];
    const { classes, estimateType } = this.props;
    const dataType = props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const setValue = (val) => {
      this.setState({ value: val });
    };
    const tabHandler = (type) => {
      setValue(type);
    };

    return (
      <React.Fragment>
        <div className="scope-time">
          <div className="container">
            <ul className="tabs-wrap">
              <li className={value === "scope" ? "active" : ""}>
                <Button onClick={() => tabHandler("scope")}>
                  <p>Scope</p>
                </Button>
              </li>
              <li className={value === "summary" ? "active" : ""}>
                <Button onClick={() => tabHandler("summary")}>
                  <p>Summary</p>
                </Button>
              </li>
              <li className={value === "notes" ? "active" : ""}>
                <Button onClick={() => tabHandler("notes")}>
                  <p>Notes</p>
                </Button>
              </li>
            </ul>
            <div className="content-wrapper">
              {value === "scope" ? (
                <div
                  className={`scope-wrap ${value === "scope" ? "active" : ""}`}
                >
                  <GanttContainerApp
                    updateCnt={this.props.updateCnt}
                    update={this.props.update}
                    estimateType={estimateType}
                  />
                </div>
              ) : null}
              {value === "summary" ? (
                <div
                  className={`summary-wrap ${value === "summary" ? "active" : ""
                    }`}
                >
                  <Summary
                    dataType={dataType}
                    dataKey={key}
                    key={"summary" + key}
                  />
                </div>
              ) : null}
              {value === "notes" ? (
                <div
                  className={`notes-wrap ${value === "notes" ? "active" : ""}`}
                >
                  <Notes />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(TimeBased);
